import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist, getlanguage } from "../../helpers/changelanguage";
import StaticFooter from "./footer";
import StaticHeader from "./header";
import FooterLink from "./footerlink";

class FAQ extends Component {

   componentDidMount(){
    
    document.querySelector('body').classList.remove('login_page');
    document.body.style.backgroundImage = "url('')";
   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      let lng           = getlanguage();
      return (
       
        <div className="static-page">    
        <StaticHeader />
        <section className="terms_conditions">
            <h2 className="text-center">{languagelist.Faq1}</h2>
                    <div className="container">

                <p><strong>{languagelist.Faq2}</strong></p>

            <p>{languagelist.Faq3}</p>

            <p><strong>{languagelist.Faq4}</strong></p>

            <p>{languagelist.Faq5}</p>

            <ul>
                <li>{languagelist.Faq6}</li>
                <li>{languagelist.Faq7}</li>
                <li>{languagelist.Faq8} <a href="https://www.baaldahab.com">https://www.baaldahab.com</a></li>
                <li>{languagelist.Faq9}</li>
                <li>{languagelist.Faq10}</li>
                <li>{languagelist.Faq11}</li>
                <li>{languagelist.Faq12}</li>
                <li>{languagelist.Faq13}</li>
                <li>{languagelist.Faq14}</li>
            </ul>

            <p>&nbsp;</p>

            <p><strong>{languagelist.Faq15}</strong></p>

            <p>{languagelist.Faq16}</p>

            <p><strong>{languagelist.Faq17}</strong></p>

            <p>{languagelist.Faq18}</p>

            <p><strong>{languagelist.Faq19}</strong></p>

            <p>{languagelist.Faq20}</p>

            <p><strong>{languagelist.Faq21}</strong></p>

            <p>{languagelist.Faq22}</p>

            <p><strong>{languagelist.Faq23}</strong></p>

            <p>{languagelist.Faq24}</p>

            <p>&nbsp;</p>

            <p>{languagelist.Faq25}</p>

            <p><strong>{languagelist.Faq26}</strong></p>

            <p>{languagelist.Faq27}</p>

            <p><strong>{languagelist.Faq28}</strong></p>

            <p>{languagelist.Faq29}</p>

            <p><strong>{languagelist.Faq30}</strong></p>

            <p>{languagelist.Faq31}</p>
            {
                (lng == 'en') ?
                <div>
                    <p><strong>What can I do with &lsquo;My Golden Spaces&rsquo;?</strong></p>
                    <p>BaalDahab has a special feature, which gives the users the opportunity to write and save their golden side of their lives. The special functionality will have the following.</p>
                    <ul>
                        <li>My Golden Friends (Here a user can edit a friend list and can choose 1-12 as his/her friends as Golden friends. This allows that user to put them in a special group under the Friend list)</li>
                        <li>My Golden Ideas (A place where the person puts all ideas that he/she sees as golden ideas-Own ideas or ideas from the other well-known figures)</li>
                        <li>My Golden Dreams (The dreams of the person, what the person wants to achieve, it may have two sections, Personal and Professional)</li>
                        <li>My Golden Sports team</li>
                        <li>My Golden Figures (Personalities, such us Sports, music, religious, political, business, authors and academics and etc)</li>
                        <li>My Golden Universities</li>
                        <li>My Golden companies</li>
                        <li>My Golden Music</li>
                        <li>My Golden Books</li>
                        <li>My Golden Movies</li>
                        <li>My Golden Games</li>
                        <li>My Golden Dates (Such us birthdays, graduation dates, wedding day, first date day, parents&rsquo; birthday, children&rsquo;s and so on)</li>
                        <li>My Golden Quran reciters</li>
                        <li>My Golden Poets</li>
                        <li>My Golden Notes (A place to save golden notes)</li>
                        <li>My Golden Memories</li>
                        <li>My Golden Tourist trips/destinations</li>
                        <li>The user can choose the privacy of these golden spaces and can decide whether to keep these in public view, share these with friends or keep these absolutely personal.</li>
                    </ul>
                </div>
                
                : 
                <div>
                    <p><strong>Maxaan ka faa&rsquo;iidayaa &lsquo;Waabteyda Dahabka ah&rsquo;?</strong></p>

                    <p>BaalDahab wuxuu leeyahay adeegyo qaas ah oo heer sare ah, kuwaas oo ku siinaya fursad aad ku qorto, keydiso, goortii aad doontidna hesho ama wax ka bedeshid, wax ku dartid, wax ka saxdid macluumaadka ku saabsan baalkaaga Dahabka ah. Adeegyada u gaarka ah waxaa ka mid ah:</p>
                        <ul>
                            <li>Saaxiibada dahabka ah (Halkan waxaad gashan kartaa 1-12 saaxiibbadaada ka mid ah oo aad u aqoonsan tahay saaxiibbada kuugu qaalisan. Taasi waxaa ay kuu sahleysaa in aad galiso liis gaar ah oo liiska saaxiibbada hoos imaanaya balse maamuus gaar ah leh.</li>
                            <li>Fikradaha Dahabka ah (Halka waxaad ku qoraneysaa, ku keydineysaa dhammaan fikradaha aad u aragtid in ay muhiim kuu yihiin, waxaa ay noqon karaa fikradahaaga ama kuwo dad kale leeyihiin balse aad u riyaaqday)</li>
                            <li>Riyooyinka Dahabka ah (Halkan waxaad ku keydsaneysaa, kalana soconeysaa riyooyinka aad dooneysid in aad mustaqbalka ka guul gaartid. Waxaad ka dhigan kartaa kuwo shaqsi ah ama kuwo shaqada la xiriira)</li>
                            <li>Kooxdeyda ciyaaraha ee dahabka ah</li>
                            <li>Shaqsiyaadka dahabka ah (Dad shaqsiyad sare kuu leh, sida: ciyaaryahanada, fanaaniinta, culumada diinta, macallimiinta, siyaasiinta, ganacsatada, qorayaasha ama halabuurka iwm)</li>
                            <li>Jaamacadeheyga dahabka ah</li>
                            <li>Shirkadaheyga dahabka ah</li>
                            <li>Heesaha dahabka ah</li>
                            <li>Buugaagta dahabka ah</li>
                            <li>Aflaanta dahabka ah</li>
                            <li>Ciyaaraha dahabka ah</li>
                            <li>Taariikhaha dahabka ah (Sida: dhalashada, qalinjabinta, arooska, maalintii cahdiga jaceylka, iwm)</li>
                            <li>Xaafidul Quraanka dahabka ah</li>
                            <li>Gabayaaga dahabka ah</li>
                            <li>Xusuus qorkeyga dahabka ah (Waa bog aad ku keydsaneyso dhammaan xusuusaha muhiimka ah iyo go&rsquo;aanada muhiimka ah ee shirarka)</li>
                            <li>Xusuus-reerbyada dahabka ah</li>
                            <li>Jihooyinka dalxiis ee dahabka ah Adiga ayaa dooran kara macluumaadkan in ay kuu xafidnaadaan oo uusan qof kale arkin iyo in aad dadka la wadaagtid intaba. Waxaad ka dhigi kartaa kuwo adiga uun arki kartid, kuwo saaxiibada dahabka ah ay arki karaan, kuwo uu qof walba arki karo, balse qof aan adiga aheyn waxba kama beddeli karo, waxna kuma dari karo.</li>
                        </ul>
   
                             <p>&nbsp;</p>

                            <p><strong>Sideen luuqadaha u bedbedeli karaa?</strong></p>

                            <p>Marka aad joogto bogga kore ee aad cinwaankaaga ka soo galeyso waxaad qeybta hoose ku arkeysaa labo luuqadood, kuwaas oo kala ah English iyo Soomaali. Luuqadda English ayaa lagu dhisay adeegga asal ahaan, iyada ayuu ku soo kacayaa, laakiin waxaad gujineysaa Luuqadda Soomaaliga si adeegga oo dhan uu isugu beddelo af Soomaali, dhammaan farriimaha adeegga ee ogeysiinta ah waxaa ay noqonayaan Soomaali. Marka aad gudaha gashay haddii aad u baahatid in aad luuqadda bedesho waxaa aad ka beddeli kartaa qeybta Habeynta. Waxaa qeybta habeynta ku dhex jira cinwaan ah &lsquo;Luuqadda&rsquo; kaas oo kuu ogolaanaya in aad isku bedesho luuqadaha Soomaaliga iyo Ingiriiska.</p>

                            <p><strong>Maxay yihiin adeegyada dheeriga ah ee aan ka helayo Cinwaanka Dahabka ah?</strong></p>

                            <p>Marka aad sameysato cinwaanka Dahabka ah ugu horreyn waxaad heleysaa Summadda Dahabka ah oo cinwaankaaga uu helayo, cinwaankaaga lama xadi karo, waxaadna bil walba heleysaa hal fursad xayeysiin bilaash ah oo soconeysa 48 saacadood, taas oo ka dhigan in aad sanad walba heleysid 12 xayeysiinood oo bilaash ah. Marka aad leedahay cinwaanka aasaasiga ah xayeysiis kasta waa lacag, waxaana qiimaha lagu jaangoynayaa hadba doorashadaada. Qiimaha cinwaanka Dahabka ah waa $19.99/Sanadkii.</p>

                            <p><strong>Xayeysiin maxay tahay?</strong></p>

                            <p>Xayeysiis waa halka aad ku xayeysiisaneyso wal walba oo aad dooneyso in ay bulshada ogaato meel walba oo ay dunida ka joogto, balse waxaad dooran kartaa dadka, magaalooyinka iyo dalalka aad si gaar ah u daneyneysid. Dadka xayeysiintaada arkaya waa dadka ku xiran adeegga BaalDahab, kuwaas oo dheehan kara marka aad dhigto xayeysiinta. 12 xayeysiinood oo lacag la&rsquo;aan ah ayaad heleysa marka aad leedahay cinwaan Dahab ah, haddii aadan cinwaan dahab ah laheyn waxaad iska bixineysaa khidmadda xayeysiinta.</p>

                            <p><strong>Sideen qof ugu gunti karaa ama ugu hibeyn karaa waxa aan soo dhigay?</strong></p>

                            <p>Marka aad dhigaalka sameyneyso waxaad arkeysaa laba meelood oo ay ku yaallaan calaamadaha gunudda iyo hibeynta. Waxaad gujineysaa midda aad rabto, kaddib waa aad hibeyn kartaa ama ku gunti kartaa qofka aad dooneysid. Marka aad gujiso labada calaamadood middood waxaa kuu furmaya liiska saaxiibada si aad uga doorato qofka aad dooneysid in aad ku gunnudid ama u hibeysid.</p>

                            <p><strong>Waa maxay bog?</strong></p>

                            <p>Bogga waa nooc xogkoobyada ka mid ah oo ka duwan kan caadiga ah. Waa in aad cinwaan leedahay, cinwaankuna xogkoob leeyahy si aad bog u sameysan kartid. Bogga waa halka aad ku bandhigeyso qormooyinkaaga, farriimahaaga, afkaartaada iyo wax walba oo macluumaad ah oo aad dooneysid in ay gaaraan dad ka badan kuwa ku xiran looxaagga. Bogga qudhiisa waxaad ka dhigi kartaa mid furan oo qof walba aqrin karo amaba mid xiran oo dadka xubnaha ka ah uun ay arki karaan. Kan xiran wuxuu kaaga baahanayaa in aad adiga ku casuunto ama ku dartid xubnaha, halka kan furan ay dadka si caadi ah uga mid noqon karaan dadka ku xiran. Bogga sidoo kale wuxuu leeyahay qeybo fikradaha la isku dhaafsado.</p>
                    
                    
                </div>
            }
            

            
                </div>

            </section>


            <section className="panel_7 text-center">
                <div className="container">
                    <FooterLink />

                    <p> {languagelist.Staticfooter1}</p>
                </div>
            </section>

        <StaticFooter />

        </div>
      
      );
    }
  }
export default FAQ;